<template>
  <div :class="{'scenario-container': !isMenuMiniSize, 'scenario-container-thin-menu': isMenuMiniSize}">
    <!-- モーダル用 -->
    <section>
      <ModalChatBotDetails
        ref="detail"
        :chatbot="selectChatbot"
        :mediaCooperationItemMasterNameList="mediaCooperationItemMasterNameList"
        :userChatBotBookMark="userChatBotBookMark"
        :users="users"
        :user="user"
        :sitemapRootList="sitemapRootList"
        :sitemapEmploymentList="sitemapEmploymentList"
        :isShowModal="isModalChatBotDetail"
        :usersStatusAPI="usersStatusAPI"
        @cancel="changeModalChatBotDetail"
        @setIcon="setIcon"
        @changeBookMark="changeBookMark"
        @movePartsEdit="movePartsEdit"
        @updateChatBot="updateChatBot"
        @deleteChatBot="deleteChatBot"
        @clickRoboLock="clickRoboLock"
        :PCTRLLOG="CTRLLOG"
      />
      <ModalCreateRoboTemplate
        :isShowModal="isCreateRoboTemplate"
        :chatbot="selectChatbot"
        @createRoboTemplate="createRoboTemplate"
        @cancel="cancelRoboTemplate"
      />
    </section>
    <ModalDeleteChatBot ref="delete" :deleteIndex="deleteIndex" @deleteComplete="deleteChatbotComplete" :PCTRLLOG="CTRLLOG"/>
    <div style="display: flex;">
      <b-modal width="680px" :active.sync="isCreateRoboPartsSetModal">
        <div class="card" style="border-radius: 5px;">
          <header class="card-header">
            <p class="card-header-title">
              パーツセットの新規作成
            </p>
          </header>
          <div class="card-content">
            <p>
              <b-message type="is-primary" has-icon>
                新規にパーツセットを作成します。
              </b-message>
            </p>
            <hr>
            <p style="padding-bottom: 0.5em;"><b>パーツセット名</b></p>
            <b-input v-model="roboPartsSetName"></b-input>
            <p style="padding-bottom: 0.5em;padding-top: 0.5em;"><b>作成者</b></p>
            <b-input v-model="roboPartsSetAuthor"></b-input>
          </div>
          <footer class="card-footer">
            <a class="card-footer-item" @click="isCreateRoboPartsSetModal = false">キャンセル</a>
            <a class="card-footer-item" @click="createRoboPartsSet()">作成</a>
          </footer>
        </div>
      </b-modal>
    </div>
    <!-- シナリオ名一覧を表示し、クリックされたシナリオの中身を一覧で表示する -->
    <div class="content-container-scenario">
      <div class="scenario-content">
        <aside class="menu menu-box">
          <!-- シナリオ一覧 -->
          <p class="title-menu">
            <span class="mdi mdi-comment-text-multiple mdi-24px" style="margin-right: 10px;"></span><b>一覧</b>
          </p>
          <!-- ロボ検索(ロボ名またはタグ) -->
          <input class="input" placeholder="🔎ロボ名orタグ名で検索" v-model="searchWords"/>
          <!-- テンプレートロボ表示 -->
          <b-checkbox
            size="is-small"
            v-model="isDispTemplate"
            v-show="user.companyName==='テンプレートロボ作成会社'"
          >
            <span>テンプレートを表示</span>
          </b-checkbox>
          <b-tabs class="robo-tabs" v-model="robo_tabs_state">
            <!-- タブ -->
            <b-tab-item
              v-for="(tabName, tabIndex) in tabNameList" :key="tabIndex"
              ref="robo_tab"
              class ="robo-tab-item disp-scroll"
              :label="tabName"
            >
              <template #header class="tab-header">
                {{tabName}}
                <b-tag class="rounded tab-header">
                  {{checkChatbots(tabName).length}}
                </b-tag>
              </template>
              <template v-if="checkChatbots(tabName).length > 0">
                <div class="menu-list">
                  <!-- ロボリスト -->
                  <div
                    class="robo-card-list"
                    v-for="robo in checkChatbots(tabName)" :key="robo.bot_id"
                    :ref="'robo_list_' + tabIndex"
                    @click="movePartsEdit(robo)"
                  >
                    <RoboCard
                      :class="{'active-menu': robo.scenario_name === selectScenarioName, 'non-active-menu': robo.scenario_name !== selectScenarioName}"
                      parent="scenario-list"
                      :robo="robo"
                      :PCTRLLOG="CTRLLOG"
                    />
                  </div>
                </div>
              </template>
              <template class="list-nothing-message" v-else>
                表示できるロボがありませんでした。
              </template>
            </b-tab-item>
          </b-tabs>
        </aside>
        <!-- シナリオメイン -->
        <div :class="{'scenario-list-box': !isMenuMiniSize, 'scenario-list-box-thin-menu': isMenuMiniSize}">
          <ScenarioList
            ref="scenario"
            :openSettingNameModal="openSettingNameModal"
            @return-goal-error-count="returnGoalErrorCount"
            @component-ready="componentReady"
            @back="changeList"
            v-if="selectScenario !== '' && !confirmLoading"
            :PCTRLLOG="CTRLLOG"
          />
          <div v-if="selectScenario === '' || confirmLoading" class="scenario-wait-content">
            <div style="margin: 10%;" v-if="isSCNLoading || confirmLoading">
              <span class="mdi mdi-loading mdi-spin mdi-48px"></span>
            </div>
          </div>
        </div>
        <!-- 設定メニュー -->
        <div class="setting-content">
          <div v-if="selectScenario !== '' && !confirmLoading">
            <!-- header -->
            <div class="header-setting">
              <!-- テンプレート化/解除（テンプレートロボ作成会社のみ表示） -->
              <div v-if="this.user.companyName==='テンプレートロボ作成会社' && !selectChatbot.is_template">
                <b-tooltip label="テンプレート化" position="is-left" type="is-dark">
                  <a @click="changeChatBotTemplate(selectChatbot.is_template)">
                    <span class="mdi mdi-briefcase-download mdi-36px" :style="{'color': activeTab(isParts)}"></span>
                  </a>
                </b-tooltip>
              </div>
              <div v-if="this.user.companyName==='テンプレートロボ作成会社' && selectChatbot.is_template">
                <b-tooltip label="テンプレート化解除" position="is-left" type="is-dark">
                  <a @click="changeChatBotTemplate(selectChatbot.is_template)">
                    <span class="mdi mdi-briefcase-upload mdi-36px" :style="{'color': activeTab(isParts)}"></span>
                  </a>
                </b-tooltip>
              </div>
              <!-- パーツ -->
              <div>
                <b-tooltip label="シナリオパーツ" position="is-left" type="is-dark">
                  <a @click="changeSetting(true, false, false)">
                    <span class="mdi mdi-expand-all mdi-36px" :style="{'color': activeTab(isParts)}"></span>
                  </a>
                </b-tooltip>
              </div>
              <!-- パーツセット -->
              <div>
                <b-tooltip label="パーツセット" position="is-left" type="is-dark">
                  <a @click="changeSetting(false, true, false)" v-if="!selectChatbot.is_confirm && !isRoboPartsSetView">
                    <span class="mdi mdi-bulletin-board mdi-36px" :style="{'color': activeTab(isTemplate)}"></span>
                  </a>
                  <a v-if="selectChatbot.is_confirm || isRoboPartsSetView" style="cursor: not-allowed; color: #E9BDB5;">
                    <span class="mdi mdi-bulletin-board mdi-36px" :style="{'color': activeTab(isTemplate)}"></span>
                  </a>
                </b-tooltip>
              </div>
              <!-- ロボ詳細 -->
              <div>
                <b-tooltip label="ロボ詳細" position="is-left" type="is-dark">
                  <a @click="showModalChatbotModal(selectChatbot)">
                    <span class="mdi mdi-robot mdi-36px"></span>
                  </a>
                </b-tooltip>
              </div>
            </div>
            <!-- body -->
            <div class="body-setting disp-scroll">
              <div class="question-button-wrapper" v-if="!isTemplate">
                <QuestionButton @click.native="openHowToUsePartsModal()" />
              </div>
              <ModalHowToUseParts
                :isShowModal="isHowToUsePartsModal"
                @cancel="cancelHowToUsePartsModal"/>
              <div class="scenario-parts-wrapper">
                <ScenarioParts :isParts="isParts" :roboLock="selectChatbot.is_confirm" :scenarioTable="scenarioTable" @dragScenarioParts="dragScenarioParts" @resetDrag="resetDrag"/>
              </div>
              <div v-if="isTemplate">
                <!-- パーツセット新規作成 -->
                <div v-if="!selectChatbot.is_confirm && !isRoboPartsSetView">
                  <a @click="isCreateRoboPartsSetModal=true">
                    <span class="mdi mdi-bulletin-board mdi-12px">パーツセット新規作成</span>
                  </a>
                </div>
                <div v-else>
                  <a>
                    <span class="mdi mdi-bulletin-board mdi-12px" style="cursor: not-allowed; color: #E9BDB5;">パーツセット新規作成</span>
                  </a>
                </div>
                <!-- パーツセット一覧 -->
                <div v-if="roboPartsSet.length === 0">
                  <span class="mdi mdi-file-outline mdi-48px"></span>
                  <p style="padding: 10px;">パーツセットが<br>存在しません。</p>
                </div>
                <div v-if="!selectChatbot.is_confirm && !isRoboPartsSetView">
                  <div class="card body-setting-template" v-for="(set, index) in roboPartsSet" :key="index" draggable="true" @dragstart="dragRoboPartsSet(set)" @dragend="resetDrag">
                    <header class="card-header">
                      <p class="card-header-title">
                        {{ set.robo_parts_set_name }}
                      </p>
                    </header>
                    <div class="card-content">
                      <p>パーツ数： {{set.scenario_list ? set.scenario_list.length : 0}}</p>
                      <p>作成者： {{set.author}}</p>
                    </div>
                    <footer class="card-footer">
                      <a class="card-footer-item" @click="dispRoboPartsSetView(set)" style="padding: 5px;">
                        <span class="mdi mdi-view-quilt mdi-24px" style="margin-right: 5px;"></span>
                        パーツセット編集
                      </a>
                    </footer>
                  </div>
                </div>
                <div v-else>
                  <div class="card body-setting-template" v-for="(set, index) in roboPartsSet" :key="index">
                    <header class="card-header" style="cursor: not-allowed; color: #E9BDB5;">
                      <p class="card-header-title" style="cursor: not-allowed; color: #E9BDB5;">
                        {{ set.robo_parts_set_name }}
                      </p>
                    </header>
                    <div class="card-content" style="cursor: not-allowed; color: #E9BDB5;">
                      <p>パーツ数： {{set.scenario_list ? set.scenario_list.length : 0}}</p>
                      <p>作成者： {{set.author}}</p>
                    </div>
                    <footer class="card-footer" style="cursor: not-allowed; color: #E9BDB5;">
                      <a class="card-footer-item" style="padding: 5px; cursor: not-allowed; color: #E9BDB5;">
                        <span class="mdi mdi-view-quilt mdi-24px" style="margin-right: 5px;"></span>
                        パーツセット編集
                      </a>
                    </footer>
                  </div>
                </div>
              </div>
              <!-- template end -->
            </div>
            <!-- body end -->
          </div>
        </div>
        <!-- setting menu end -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState }        from 'vuex'
import Tooltip             from '@/components/atoms/tooltips/Tooltip'
import ScenarioParts       from '@/views/DashBoard/ChatBot/ScenarioParts'
import ScenarioList        from '@/views/DashBoard/ChatBot/ScenarioList'
import QuestionButton      from '@/components/atoms/buttons/QuestionButton'
import ModalHowToUseParts  from '@/components/organisms/modals/ModalHowToUseParts'
import ModalChatBotDetails from '@/components2/Robo/modal/organisms/ModalChatBotDetails'
import ModalDeleteChatBot  from '@/components/ui/ModalDeleteChatBot'
import RoboCard            from '@/components2/Robo/modal/RoboCard'
import controlLogMixin     from '@/mixins/controlLogMixin'
import ModalCreateRoboTemplate from '@/components2/Robo/modal/organisms/ModalCreateRoboTemplate'
import {
  isRoboEditPermission
} from '@/functions/checkPermission'

export default {
  name: 'ScenarioView',
  componentName: 'ScenarioView',
  components: {
    Tooltip,
    ScenarioParts,
    ScenarioList,
    QuestionButton,
    ModalHowToUseParts,
    ModalChatBotDetails,
    ModalDeleteChatBot,
    RoboCard,
    ModalCreateRoboTemplate
  },
  mixins: [
    controlLogMixin
  ],
  created () {
    this.$store.dispatch('chatbot/getChatBots')
    if (this.$route.query.is_template) {
      this.isDispTemplate = true
    }
  },
  computed: {
    ...mapState('chatbot', ['chatbots', 'selectScenario', 'scenarioTable', 'isSCNLoading', 'roboPartsSet', 'selectChatbot', 'selectScenarioName', 'scenarioTitleBeforeChange', 'isModalChatBotDetail', 'roboPartsSet', 'isRoboPartsSetView', 'confirmLoading', 'chatbotStatus', 'selectScenarioList']),
    ...mapState('auth', ['user', 'users', 'userChatBotBookMark', 'usersStatusAPI']),
    ...mapState('mediapool', ['images']),
    ...mapState('sitemap', ['sitemapRootList', 'sitemapEmploymentList']),
    ...mapState("setting",["isMenuMiniSize"]),
    // 媒体連携関連ストア
    ...mapState('recruitmentMedia', [
      // 媒体連携項目マスター一覧
      'mediaCooperationItemMasterNameList',
    ]),
  },
  data () {
    return {
      isParts: true,
      isTemplate: false,
      isDispTemplate: false,
      isChatbotInfo: false,
      isHowToUsePartsModal: false,
      isGoalError: false,
      isGoalErrorChecked: false,
      isTagErrorChecked: false,
      deleteIndex: null,
      isCreateRoboPartsSetModal: false,
      roboPartsSetName: null,
      roboPartsSetAuthor: null,
      tabNameList: ['ロック中', '編集中'],
      searchWords: null,
      isCreateRoboTemplate: false,
      robo_tabs_state: 0,
    }
  },
  watch: {
    chatbots () {
      this.scrollToSelectedCard()
    },
    selectScenarioName () {
      this.scrollToSelectedCard()
    },
  },
  created () {
    // 媒体連携項目マスター一覧取得
    this.$store.dispatch('recruitmentMedia/getMediaCooperationItemMasterList')
  },
  mounted () {
    this.scrollToSelectedCard()
  },
  methods: {
    openSettingNameModal () {
      this.changeModalChatBotDetail(true)
      this.$refs.detail.changeChatBotSetting(true)
      this.$store.dispatch('chatbot/setIsChangeName', true)
    },
    changeModalChatBotDetail (flg) {
      this.$store.dispatch('chatbot/setModalChatBotDetail', flg)
      this.$refs.detail.changeChatBotSetting(false)
    },
    showModalChatbotModal (chatbot) {
      var chat = []
      for (var c of this.chatbots) {
        if (c.bot_id == chatbot.bot_id) {
          chat = c
        }
      }
      this.$store.dispatch('chatbot/selectChatbot', chat)
      this.changeModalChatBotDetail(true)
    },
    scrollToSelectedCard () {
      let index, tabIndex
      for (tabIndex = 0; tabIndex < this.tabNameList.length; tabIndex++) {
        let bots = this.checkChatbots(this.tabNameList[tabIndex])
        index = bots.findIndex((bot) => bot.scenario_name === this.selectScenarioName)
        if (index != -1) break
      }
      if (index != -1) {
        this.robo_tabs_state = tabIndex
        this.$nextTick(() => {
          let offsets = this.$refs['robo_list_' + tabIndex].map((a) => a.offsetTop)
          offsets.sort((a, b) => a-b)// $refsの順番は保証されないので並び替え
          this.$refs.robo_tab[tabIndex].$el.scrollTo({
            top: offsets[index],
            behavior: 'smooth'
          })
        })
      }
    },
    // 権限確認
    userCheck (chatbot) {
      return isRoboEditPermission(chatbot, this.user)
    },
    // シナリオへ
    movePartsEdit (chatbot) {
      // GOAL設定エラーチェック
      let ret = this.checkGoalError()
      if (ret) {
        // GOAL設定エラーなしなら、タグチェックへ
        let ret2 = this.checkTagError()
        if (ret2) {
          // タグ設定エラーなしなら、遷移する
          this.$store.dispatch('chatbot/scenarioPastCancel')
          this.$store.dispatch('chatbot/setScenarioTitleBeforeChange', '')
          this.$store.dispatch('chatbot/getScenario', { companyid: this.user.companyID, scenarioName: chatbot.scenario_name })
          this.$store.dispatch('chatbot/selectChatbot', chatbot)
        }
        this.$router.push('/dashboard/chatbot?view=scenario&scenario=' + chatbot.scenario_name)
      }
    },
    // パーツセットへ
    dispRoboPartsSetView (roboPartsSet) {
      // GOAL設定エラーチェック
      let ret = this.checkGoalError()
      if (ret) {
        // GOAL設定エラーなしなら、タグチェックへ
        let ret2 = this.checkTagError()
        if (ret2) {
          // タグ設定エラーなしなら、遷移する
          this.$store.dispatch('chatbot/scenarioPastCancel')
          this.$store.dispatch('chatbot/dispRoboPartsSetView', roboPartsSet)
          this.$router.push('/dashboard/chatbot?view=scenario')
          this.changeSetting(true, false, false)
        }
      }
    },
    // 一覧へ
    changeList () {
      this.$router.push('/dashboard/chatbot')
    },
    activeTab (flg) {
      if (flg) return 'black'
    },
    dragScenarioParts (i, event) {
      this.$store.dispatch('chatbot/changeIsDrop', i)
    },
    dragRoboPartsSet (s, event) {
      const data = {
        index: 100,
        roboPartsSet: s
      }
      this.$store.dispatch('chatbot/changeIsDropList', data)
    },
    resetDrag () {
      this.$store.dispatch('chatbot/changeIsDrop', -1)
    },
    resetDragList () {
      const data = {
        index: -1,
        roboPartsSet: null
      }
      this.$store.dispatch('chatbot/changeIsDropList', data)
    },
    hoverSelect (scnName, flg) {
      this.isDetailHover = flg
      this.detailScnName = scnName
    },
    openHowToUsePartsModal () {
      this.isHowToUsePartsModal = true
    },
    cancelHowToUsePartsModal () {
      this.isHowToUsePartsModal = false
    },
    changeSetting (parts, template, info) {
      this.isParts = parts
      this.isTemplate = template
      this.isChatbotInfo = info
    },
    // ミニロボ有無チェック
    isMiniBot (chatbot) {
      let isMini = false
      if (chatbot.chatbot_mini) {
        if (chatbot.chatbot_mini.length > 0) {
          isMini = true
        }
      }
      return isMini
    },
    // お気に入り更新
    changeBookMark (bot) {
      let bkCB = null
      this.isBKMKLoading = true
      for (const cb of this.userChatBotBookMark) {
        if (cb.chatbot === bot.bot_id) {
          bkCB = cb
          break
        }
      }
      if (bkCB) {
        this.$store.dispatch('auth/deleteUserChatBotBookMark', bkCB.pk)
      } else {
        let cbTemp = {
          chatbot: bot.bot_id,
          user: this.user.userHash
        }
        this.$store.dispatch('auth/createUserChatBotBookMark', cbTemp)
      }
    },
    // ICON 更新
    setIcon (data) {
      // ミニロボの画像変更とそれ以外
      if (data.miniIdx >= 0) {
        let updateChatBotMiniTemp = data.chatbot.chatbot_mini[data.miniIdx]
        if (data.id) {
          for (const i of this.images) {
            if (i.image_id == data.id) {
              updateChatBotMiniTemp["icon_ref"] = i.pk
              updateChatBotMiniTemp["icon_data"] = i.image_data
              this.$store.dispatch('chatbot/updateChatBotMini', updateChatBotMiniTemp)
              break
            }
          }
        } else {
          updateChatBotMiniTemp["icon_ref"] = null
          updateChatBotMiniTemp["icon_data"] = null
          this.$store.dispatch('chatbot/updateChatBotMini', updateChatBotMiniTemp)
        }
      } else {
        this.$store.dispatch('chatbot/setChatBotIcon', {
          name: data.chatbot.name,
          id: data.chatbot.bot_id,
          image_id: data.id
        })
      }
    },
    // ロボ更新
    updateChatBot (chatbot) {
      this.$store.dispatch('chatbot/setChatBot', chatbot)
    },
    // ロボ削除
    deleteChatBot (chatbot) {
      this.$refs.delete.chatBotDeleteFlag = true
      this.deleteIndex = chatbot.bot_id
    },
    deleteChatbotComplete () {
      alert('削除しました。ロボ社員一覧に戻ります。')
      location.href = process.env.OWN_ENDPOINT + '/client/chatbot/'
    },
    // URL設定
    cbUrlSetting (cb) {
      if (cb.chatbot_mini.length === 0) {
        this.cbInfo = cb
        this.isURLSetting = true
      } else {
        alert('ミニロボを出動させるには「ミニロボリスト ＞　配置設定」より設定をお願いいたします。')
        this.showInfoView(cb)
      }
    },
    // タグ設定
    createChatBotTags (data) {
      if (!data.tag) {
        return
      } else {
        for (const t of data.chatbot.chatbot_tag) {
          if (t.name === data.tag.pk) {
            alert('同一のタグ名が既に登録されております。')
            return
          }
        }
      }
      let temp = {
        name: data.tag,
        company: this.user.companyPK
      }
      this.$store.dispatch('chatbot/createChatBotTag', temp)
    },
    // タグ削除
    deleteChatBotTags (data) {
      this.$store.dispatch('chatbot/deleteChatBotTag', data.tag.pk)
    },
    /** ページ内遷移時GOAL設定エラーチェック */
    checkGoalError () {
      this.isGoalErrorChecked = true
      // GOAL設定エラーチェック
      this.$refs.scenario.checkGoalErrorCount()
      let ret = true
      if (this.isGoalError) {
        // GOAL設定エラーあり
        ret = confirm('ゴールが一つも設定されていません。画面を移動してもよろしいですか？')
      }
      // 確認ダイアログでOKなら操作あり、キャンセルなら操作なし
      this.isGoalErrorChecked = ret

      return ret
    },
    /** タグ設定エラーチェック */
    checkTagError () {
      this.isTagErrorChecked = true
      let ret = true
      if (this.selectChatbot.tag.length === 0) {
        ret = confirm('タグが一つも設定されていません。画面を移動してもよろしいですか？')
      }
      // 確認ダイアログでOKなら操作あり、キャンセルなら操作なし
      this.isTagErrorChecked = ret

      return ret
    },
    /** 操作フラグ取得 */
    isOpeFlag () {
      this.$emit('return-ope-flag', this.isGoalErrorChecked)
    },
    /** GOAL設定エラーチェック */
    checkGoalErrorCount () {
      // GOAL設定エラーチェック
      this.$refs.scenario.checkGoalErrorCount()
    },
    /** 操作フラグクリア */
    clearOpeInfo () {
      this.isGoalError = false
      this.isGoalErrorChecked = false
      // 子コンポーネントの操作フラグクリア
      this.$refs.scenario.clearOpeInfo()
    },
    /** GOAL設定エラー通知 */
    returnGoalErrorCount (isError) {
      this.isGoalError = isError
      if (!this.isGoalErrorChecked) {
        // 親コンポーネントでの画面遷移
        this.$emit('return-goal-error-count', isError)
      }
    },
    /** コンポーネント準備通知 */
    componentReady (ret) {
      this.$emit('component-ready', ret)
    },
    /** 新規パーツセット作成 */
    createRoboPartsSet () {
      if (!this.roboPartsSetName || !this.roboPartsSetAuthor) {
        alert("パーツセット名と作成者を入力してください")
        return
      }
      const data = {
        robo_parts_set_name: this.roboPartsSetName,
        company: this.user.companyPK,
        author: this.roboPartsSetAuthor
      }
      this.$store.dispatch('chatbot/createRoboPartsSet', data)

      this.roboPartsSetName = null
      this.roboPartsSetAuthor = null
      this.isCreateRoboPartsSetModal = false
    },
    clickRoboLock (chatbot) {
      this.$store.dispatch('chatbot/setChatBot', chatbot)
    },
    checkChatbots (tabName) {
      const isLock = tabName === '編集中' ? false : true
      if (this.user.companyName !== 'テンプレートロボ作成会社') {
        // テンプレートロボ作成会社ではない場合、念のためfalseを入れておく
        this.isDispTemplate = false
      }
      let findRoboList = []
      let roboList = this.chatbots.filter(robo => isRoboEditPermission(robo, this.user) === true && robo.is_template == this.isDispTemplate)
      if (roboList) {
        findRoboList = roboList.filter(robo => robo.is_archive === false && robo.is_confirm === isLock)
        if (this.searchWords) {
          findRoboList = findRoboList.filter(
            robo =>
            // ロボ管理名に部分一致
            robo.name.indexOf(this.searchWords) >= 0 ||
            // ロボ表示名に部分一致
            (robo.display_name && robo.display_name.indexOf(this.searchWords) >= 0) ||
            // 付与されているタグ名に部分一致
            (robo.chatbot_tag && robo.chatbot_tag.find(tag => tag.name.indexOf(this.searchWords) >= 0))
          )
        }
      }
      return findRoboList
    },
    changeChatBotTemplate (flg, bot) {
      if (flg) {
        // テンプレート化解除
        if (!confirm('テンプレート化を解除してよろしいですか？')) {
          return
        }

        // chatbotのテンプレートフラグセット
        this.selectChatbot.is_template = false
        this.updateChatBot(this.selectChatbot)

        // 通常ロボリストを表示し、現在のロボシナリオを表示する
        this.isDispTemplate = false
      } else {
        // テンプレート化
        if (!confirm('テンプレート化してよろしいですか？')) {
          return
        }

        // ロボテンプレート作成モーダル表示
        this.isCreateRoboTemplate = true
      }
    },
    createRoboTemplate (cb) {
      // chatbotのテンプレートフラグセット
      cb.is_template = true
      this.updateChatBot(cb)
      // chatbotのデータ再取得
      this.$store.dispatch('chatbot/selectChatbot', cb)

      // テンプレートリストを表示し、現在のロボシナリオを表示する
      this.isDispTemplate = true
      this.cancelRoboTemplate()
    },
    cancelRoboTemplate () {
      this.isCreateRoboTemplate = false
    },
  },
}
</script>

<style lang="scss" scoped>
.scenario-container {
  height: 100vh;
  width: calc(100% - 205px);
  display: flex;
  justify-content: left;
}
.scenario-container-thin-menu {
  height: 100vh;
  width: calc(100% - 55px);
  display: flex;
  justify-content: left;
}
.template-disp-switch {
  font-size: 10px;
  font-weight: 600;
  margin-left: auto;
}
// タブ
.robo-tabs {
  padding: 8px;
  margin-bottom: 0px;
}
.tab-header {
  padding: 4px;
  font-size: 12px;
  font-weight: 600;
}
.robo-tab-item {
  padding: 8px;
  width: 100%;
}
.content-container-scenario {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  .scenario-wait-content {
    align-items: center;
  }
  .scenario-content {
    background: #fff;
    height: 100vh;
    display: flex;
    .scenario-list-box {
      width: calc(100vw - 670px);
    }
    .scenario-list-box-thin-menu {
      width: calc(100vw - 520px);
    }
    .menu-box {
      background: #fff;
      border-right: solid thin #ccc;
      width: 260px;
      height: 100vh;
      .title-menu {
        height: 50px;
        display: flex;
        align-items: center;
        padding-left: 10px;
        border-bottom: solid thin #ccc;
      }
      .menu-list {
        height: calc(100vh - 190px);
        .active-menu {
          background-color: rgb(244, 204, 219) !important;
          padding: 4px;
        }
        .non-active-menu {
          padding-left: 4px;
        }
      }
    }
    .setting-content {
      background: #fff;
      width: 200px;
      height: 100vh;
      justify-content: center;
      align-items: flex-start;
      .header-setting {
        display: flex;
        height: 50px;
        flex-wrap: nowrap;
        justify-content: space-between;
        border-left: solid thin #ccc;
        border-bottom: solid thin #ccc;
        align-items: center;
        padding: 0.5em;
      }
      .body-setting {
        height: calc(100vh - 50px);
        border-left: solid thin #ccc;
        background: #FEFEFE;
        .question-button-wrapper {
          position: fixed;
          right: 16px;
          z-index: 20;
          padding: 8px 0;
        }
        .body-setting-template {
          border-radius: 5px;
          margin: 10px;
        }
        .card-header-title {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          .idx {
            text-align: left;
            width: 32px;
            font-weight: normal;
          }
          &-span {
            padding-left: 4px;
            font-weight: normal;
            font-size: 12px;
          }
          .image-wrapper {
            .image {
              width: 48px;
              height: 48px;
              border-radius: 50%;
              object-fit: cover;
              background: white;
            }
          }
          .mini-name {
            margin-left: 8px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/ChatBot/ScenarioView.vue